import { GlButton, GlModal, GlModalDirective, GlTooltipDirective, GlSprintf, GlLink, GlFormInputGroup, GlToastMixin } from '@gitlab/ui';
import axios from '~/lib/utils/axios_utils';
import { __ } from '~/locale';
import * as Sentry from '~/sentry/sentry_browser_wrapper';
import SimpleCopyButton from '~/vue_shared/components/simple_copy_button.vue';
export default {
    i18n: {
        sendEmail: __('Send email'),
        emailNewMergeRequest: __('Email a new merge request to this project'),
        createNewMergeRequestByEmail: __('Create new merge request by email'),
        failedToResetEmail: __('There was an error when resetting email token.'),
        mergeRequestCreationInstruction: __('You can create a new merge request inside this project by sending an email to the following email address:'),
        emailSubjectDescription: __('The subject is used as the title of the new merge request, and the message is the description. %{quickActionsLinkStart}Quick actions%{quickActionsLinkEnd} and styling with %{markdownLinkStart}Markdown%{markdownLinkEnd} are supported.'),
        privateEmailWarning: __('This is a %{emailsHelpLinkStart}private email address%{emailsHelpLinkEnd} generated just for you. Anyone who has it can create merge requests as if they were you. If that happens, %{resetLinkStart}reset this token%{resetLinkEnd}.')
    },
    name: 'MergeRequestByEmail',
    components: {
        GlButton,
        GlModal,
        GlSprintf,
        GlLink,
        GlFormInputGroup,
        SimpleCopyButton
    },
    directives: {
        GlModal: GlModalDirective,
        GlTooltip: GlTooltipDirective
    },
    mixins: [
        GlToastMixin
    ],
    inject: {
        initialEmail: {
            default: ''
        },
        emailsHelpPagePath: {
            default: ''
        },
        quickActionsHelpPath: {
            default: ''
        },
        markdownHelpPath: {
            default: ''
        },
        resetPath: {
            default: ''
        }
    },
    data () {
        return {
            email: this.initialEmail,
            isResetting: false
        };
    },
    computed: {
        mailToLink () {
            const subject = __('Enter the merge request title');
            const body = __('Enter the merge request description');
            return `mailto:${this.email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
        }
    },
    methods: {
        async resetIncomingEmailToken () {
            if (this.isResetting || !this.resetPath) return;
            this.isResetting = true;
            try {
                const { data: { new_address: newAddress } } = await axios.put(this.resetPath);
                this.email = newAddress;
            } catch (error) {
                this.$toast.show(this.$options.i18n.failedToResetEmail);
                Sentry.captureException(error);
            } finally{
                this.isResetting = false;
            }
        },
        cancelHandler () {
            this.$refs.modal.hide();
        }
    },
    modalId: 'merge-request-email-modal'
};
